import React from "react";

import { Icon, Dropdown, Menu } from "antd";
import { deleteAccessToken } from "../../util/Auth.js";
import { Link } from "react-router-dom";
import PageTitle from "./PageTitle";

const MobileHeader = props => {
  const { name } = props;

  const userMenu = () => (
    <Dropdown overlay={menu} trigger={["click"]}>
      <div className="rightHeader">
        <div className="userMenu">{name}</div>
        <img alt="user IMG" src={`${process.env.PUBLIC_URL}/assets/user.png`} />
      </div>
    </Dropdown>
  );

  const logout = () => {
    deleteAccessToken();
    window.location = "/equipmentfinder/login";
  };

  const menu = (
    <Menu>
      <Menu.Item>
        <a href="https://rainforrent.okta.com/app/UserHome">
          <Icon type="user" /> My profile
        </a>
      </Menu.Item>
      <Menu.Item onClick={logout}>
        <Icon type="poweroff" /> Logout
      </Menu.Item>
    </Menu>
  );

  const sideMenu = (
    <Menu>
      <Menu.Item>
        <Link to="/equipment?clear=true">
          <div className="sideMenuCell">Home</div>
        </Link>
      </Menu.Item>
      <Menu.Item>
        <Link to="/about">
          <div className="sideMenuCell">About</div>
        </Link>
      </Menu.Item>
    </Menu>
  );

  return (
    <div className="header">
      <div className="leftHeader">
        <div>
          <Dropdown overlay={sideMenu} trigger={["click"]}>
            <Icon type={"menu-fold"} style={{ fontSize: "30px" }} />
          </Dropdown>
        </div>
        <PageTitle />
      </div>
      {userMenu()}
    </div>
  );
};

export default MobileHeader;
